export interface ParsedWordList {
  name: string;
  words: string[];
}

/**
 * The two import shapes the desktop app accepted, kept verbatim because people have files in them.
 *
 * `.csv` — one list per line, `listName,word,word,…`, so a single file can carry a whole library.
 * `.txt` — the filename is the list name and every line is a word.
 *
 * Parsing only. Whether a name collides with an existing list, and therefore merges into it, is the
 * caller's business — that needs the store.
 */
export function parseWordListFile(content: string, fileName: string): ParsedWordList[] {
  const isCsv = fileName.toLowerCase().endsWith('.csv');

  if (isCsv) {
    return content
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0)
      .map((line) => {
        const [name, ...words] = line.split(',').map(part => part.trim());
        return {name, words: words.filter(word => word.length > 0)};
      })
      .filter(list => list.name.length > 0 && list.words.length > 0);
  }

  const words = content
    .split('\n')
    .map(line => line.trim())
    .filter(line => line.length > 0);

  if (words.length === 0) {
    return [];
  }

  return [{name: fileName.replace(/\.(txt|csv)$/i, '') || 'Imported list', words}];
}
